<div *ngIf="interface.type == 'default'" class="bh-block bh-block-seen-default">
    <h2 class="bh-block-title">As seen in:</h2>
    <p class="bh-block-subtitle"></p>
    <div class="bh-block-list">
        <ng-container *ngFor="let seen of interface.list | random; let f = index">
            <div class="bh-seen">
                <img ngSrc="{{seen.thumbnail.src}}" alt="{{seen.alt}}" width="144" height="144">
            </div>
        </ng-container>
    </div>
</div>

<div *ngIf="interface.type == 'store'" class="bh-block bh-block-seen-store">
    <h2 class="bh-block-title">As seen in:</h2>
    <div class="bh-block-list">
        <ng-container *ngFor="let seen of interface.list | random | slice:0:7; let f = index">
            <div class="bh-seen">
                <img src="{{seen.thumbnail.src}}" alt="{{seen.alt}}">
            </div>
        </ng-container>
    </div>
</div>
